export default "__VITE_ASSET__dUNVmg0A__"